module.exports = __webpack_public_path__ + "img/DNL_FACTORY.db8bc854.jpg";